var React = require('react');

function ArrowInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M13.858 4.75822C13.4187 4.31888 12.7063 4.31888 12.267 4.75822C11.8277 5.19756 11.8277 5.90987 12.267 6.3492L17.097 11.1792H5.18774C4.56642 11.1792 4.06274 11.6829 4.06274 12.3042C4.06274 12.9255 4.56642 13.4292 5.18774 13.4292H17.096L12.267 18.2582C11.8277 18.6975 11.8277 19.4099 12.267 19.8492C12.7063 20.2885 13.4187 20.2885 13.858 19.8492L20.608 13.0992C21.0473 12.6599 21.0473 11.9476 20.608 11.5082L13.858 4.75822Z"}));
}

ArrowInline.defaultProps = {"width":"25","height":"25","viewBox":"0 0 25 25"};

module.exports = ArrowInline;

ArrowInline.default = ArrowInline;
